import {debugLog} from "../Utils/LogUtils";
import {isGroupPlanAvailable, PLAN_TYPE_IDS} from '../Utils/PlanUtils';
import {useEffect} from "react";
export default function useIsGroupPlanAllowed(state) {
    //If the group plan is being selected but it is not allowed, reset to an unselected plan
    useEffect(() => {
        if (!state.enrollment.state) { return; }
        if (state.plan.planTypeID === PLAN_TYPE_IDS.GROUP) {
            if (!isGroupPlanAvailable(state) && state.plan.planTypeID !== -1) {
                state.setPlan(prevData => ({...prevData, planTypeID: -1}));
            }
        }
        debugLog("useIsGroupPlanAllowed");
    }, [state.plan.planTypeID]);
}